import { Intervention } from '@agroone/entities'

export class GroupedInterventionByName {
  name: string
  interventions: Intervention[]
  constructor(name: string) {
    this.name = name
    this.interventions = []
  }
}
